/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { useStateMachine } from 'little-state-machine'
import { Controller, useForm, useFieldArray } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { updateCreateEvent } from './actions'
import { useNavigate } from 'react-router-dom'
import { SchemaEvent } from './schemas'
import { AlertErrorForm } from '../../../components/AlertErrorForm'
import { FormButtons } from '../../../components/Events/FormButtons'
import { categoryService } from '../../../services/category.service'
import Select from 'react-select'
import { convertToBase64 } from '../../../utils'
import { stateService } from '../../../services/state.services'
import './style.scss'

export const InformationEvent = () => {
  const [categories, setCategories] = useState([])
  const [states, setStates] = useState([])
  const { actions, state: { createEvent } } = useStateMachine({ updateCreateEvent })

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(SchemaEvent),
    defaultValues: createEvent
  })

  useEffect(() => {
    const getInitialCatalogs = async () => {
      const categories = await categoryService.getAllCategories()
      setCategories(categories.map(c => ({
        label: c.nombre,
        value: c.id
      })))
      const states = [
        { value: '1', label: 'Aguascalientes' },
        { value: '2', label: 'Baja California' },
        { value: '3', label: 'Baja California Sur' },
        { value: '4', label: 'Campeche' },
        { value: '5', label: 'Chiapas' },
        { value: '6', label: 'Chihuahua' },
        { value: '7', label: 'Ciudad de México' },
        { value: '8', label: 'Coahuila' },
        { value: '9', label: 'Colima' },
        { value: '10', label: 'Durango' },
        { value: '11', label: 'Estado de México' },
        { value: '12', label: 'Guanajuato' },
        { value: '13', label: 'Guerrero' },
        { value: '14', label: 'Hidalgo' },
        { value: '15', label: 'Jalisco' },
        { value: '16', label: 'Michoacán' },
        { value: '17', label: 'Morelos' },
        { value: '18', label: 'Nayarit' },
        { value: '19', label: 'Nuevo León' },
        { value: '20', label: 'Oaxaca' },
        { value: '21', label: 'Puebla' },
        { value: '22', label: 'Querétaro' },
        { value: '23', label: 'Quintana Roo' },
        { value: '24', label: 'San Luis Potosí' },
        { value: '25', label: 'Sinaloa' },
        { value: '26', label: 'Sonora' },
        { value: '27', label: 'Tabasco' },
        { value: '28', label: 'Tamaulipas' },
        { value: '29', label: 'Tlaxcala' },
        { value: '30', label: 'Veracruz' },
        { value: '31', label: 'Yucatán' },
        { value: '32', label: 'Zacatecas' }
      ]
      setStates(states.map(c => ({
        label: c.label,
        value: c.value
      })))
    }
    getInitialCatalogs()
  }, [])

  const navigate = useNavigate()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'funciones'
  })

  const onSubmit = async (data) => {
    console.log('Hola')
    const { itinerario, foto_portada, estado, fecha_funcion, fecha_fin } = data
    const baseImage64 = await convertToBase64(foto_portada[0])
    let formatInfo = {
      ...data,
      foto_portada: baseImage64
    }
    formatInfo = {
      ...data,
      estado: estado
      // fecha_funcion: fecha_funcion.toString(),
      // fecha_fin: fecha_fin.toString()
    }

    if (itinerario[0]) {
      const baseFile64 = itinerario && await convertToBase64(itinerario[0])
      formatInfo = {
        ...formatInfo,
        itinerario_evento: baseFile64
      }
    }

    console.log(formatInfo)
    actions.updateCreateEvent({ payload: formatInfo })
    navigate('/crear-evento/informacion-boletos')
  }

  return (
    <>
      <h1 className="h2 pt-xl-1 pb-3 text-primary">Información del evento</h1>
      {/* Basic info */}
      <h2 className="h5 text-primary mb-4">Datos del evento</h2>
      <form className="needs-validation border-bottom pb-3 pb-lg-4" onSubmit={handleSubmit(onSubmit)}>
        <div className="row pb-2">
          <div className="col-sm-12 mb-4">
            <label htmlFor="nombre" className="form-label fs-base text-white">Nombre del evento</label>
            <input type="text"
              id="nombre" className="form-control form-control-lg"
              {...register('nombre')}
            />
            {errors.nombre && (<AlertErrorForm messageError={errors.nombre.message} />)}
          </div>
          <div className="col-sm-12 mb-4">
            <label htmlFor="descripcion" className="form-label fs-base text-white">Descripcion del evento</label>
            <textarea type="text"
              id="descripcion" className="form-control form-control-lg"
              {...register('descripcion')}
            />
            {errors.descripcion && (<AlertErrorForm messageError={errors.descripcion.message} />)}
          </div>
          {/* <div className="row flex">
          <div className="col-sm-4 mb-4">
            <label htmlFor="fecha_evento"
              className="form-label fs-base text-white">
              Fecha de inicio de función
            </label>
            <input
              type="date"
              id="fecha_funcion"
              className="form-control form-control-lg"
              {...register('fecha_funcion'.toString())}
            />
            {errors.fecha_funcion && (<AlertErrorForm messageError='Fecha inválida' />)}
          </div>
          <div className="col-sm-4 mb-4">
            <label htmlFor="fecha_evento"
              className="form-label fs-base text-white">
              Fecha de fin de función
            </label>
            <input
              type="date"
              id="fecha_fin"
              className="form-control form-control-lg"
              {...register('fecha_fin'.toString())}
            />
            {errors.fecha_fin && (<AlertErrorForm messageError='Fecha inválida' />)}
            </div>
          </div>
          <div className="row flex">
          <div className="col-sm-4 mb-4">
            <label htmlFor="hora_inicio" className="form-label fs-base text-white">Hora inicial</label>
            <input type="time"
              id="hora_inicio"
              className="form-control form-control-lg"
              {...register('hora_inicio')}
            />
            {errors.hora_inicio && (<AlertErrorForm messageError={errors.hora_inicio.message} />)}
          </div>
          <div className="col-sm-4 mb-4">
            <label htmlFor="hora_final" className="form-label fs-base text-white">Hora final</label>
            <input type="time"
              id="hora_final"
              className="form-control form-control-lg"
              {...register('hora_final')}
            />
            {errors.hora_fin && (<AlertErrorForm messageError={errors.hora_fin.message} />)}
          </div>
          </div> */}
                  {
                    fields.map((item, index) => {
                      return (
                        <div key={item.id} className='form-control my-2 col-3'>
                          <div className="row flex">
                          <div className="col-sm-4 mb-4">
                            <label htmlFor="date-input" className="form-label">
                              Fecha de inicio de la funcion
                            </label>
                            <Controller
                              name={`funciones.${index}.fecha_funcion`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  type="date" id="fecha_funcion"
                                />
                              )}
                            />
                          </div>
                          <div className="col-sm-4 mb-4">
                            <label htmlFor="date-input" className="form-label">
                            Fecha de fin de función
                            </label>
                            <Controller
                              name={ `funciones.${index}.fecha_fin`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  type="date"
                                  id="fecha_fin"
                                />
                              )}
                            />
                          </div>
                          </div>
                          <div className="row flex">
                          <div className="col-sm-4 mb-4">
                            <label htmlFor="time-input" className="form-label">
                            Hora inicial
                            </label>
                            <Controller
                              name={`funciones.${index}.hora_inicio`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  type="time"
                                  id="hora_inicio"
                                />
                              )}
                            />
                          </div>
                          <div className="col-sm-4 mb-4">
                            <label htmlFor="time-input" className="form-label">
                            Hora final
                            </label>
                            <Controller
                              name={`funciones.${index}.hora_fin`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  type="time"
                                  id="hora_fin"
                                />
                              )}
                            />
                          </div>
                          </div>
                          <button
                            type="button"
                            className='btn btn-danger btn-sm'
                            onClick={() => remove(index)}
                          >
                            Eliminar horario
                          </button>
                        </div>
                      )
                    })
                  }
                  <button type="button" className='btn btn-secondary btn-lg' onClick={() => append({})}>
                    Agregar horario
                  </button>
          <div className="col-sm-6 mb-4">
            <label htmlFor="ubicacioni" className="form-label fs-base text-white">Nombre del lugar</label>
            <input type="text" id="ubicacioni"
              className="form-control form-control-lg"
              {...register('ubicacioni')}
            />
            {errors.ubicacioni && (<AlertErrorForm messageError={errors.ubicacioni.message} />)}
          </div>
          <div className="col-sm-3 mb-4">
            <label htmlFor="latitud" className="form-label fs-base text-white">Latitud</label>
            <input type="text" id="latitud"
              className="form-control form-control-lg"
              {...register('latitud')}
            />
            {errors.latitud && (<AlertErrorForm messageError={errors.latitud.message} />)}
          </div>
          <div className="col-sm-3 mb-4">
            <label htmlFor="longitud" className="form-label fs-base text-white">Longitud</label>
            <input type="text" id="longitud"
              className="form-control form-control-lg"
              {...register('longitud')}
            />
            {errors.longitud && (<AlertErrorForm messageError={errors.longitud.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4">
            <label htmlFor="estado" className="form-label fs-base text-white">Selecciona el estado</label>
            <Controller
              name="estado"
              control={control}
              render={({ field }) =>
                <Select
                  {...field}
                  className='state-input'
                  placeholder="Selecciona estado"
                  options={states}
                />}
            />
            {errors.estado && (<AlertErrorForm messageError={errors.estado.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4">
            <label htmlFor="ciudad" className="form-label fs-base text-white">Ciudad</label>
            <input type="text"
              id="ciudad" className="form-control form-control-lg"
              {...register('ciudad')}
            />
            {errors.ciudad && (<AlertErrorForm messageError={errors.ciudad.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4 text-white">
            <label htmlFor="direccion" className="form-label fs-base text-white">Dirección del evento</label>
            <input type="text"
              id="direccion" className="form-control form-control-lg"
              {...register('direccion')}
            />
            {errors.direccion && (<AlertErrorForm messageError={errors.direccion.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4">
            <label htmlFor="video" className="form-label fs-base text-white">Url de video youtube (Opcional)</label>
            <input type="text" id="video"
              className="form-control form-control-lg"
              {...register('video')}
            />
            {errors.url_video && (<AlertErrorForm messageError={errors.url_video.message} />)}
          </div>
          <div className="col-sm-12 mb-4">
            <label htmlFor="categorias" className="form-label fs-base text-white">Selecciona la categoria a las que pertenece tu evento</label>
            <Controller
              name="categorias"
              control={control}
              render={({ field }) =>
              <Select
                  {...field}
                  placeholder="Selecciona las categorias del evento"
                  isMulti
                  options={categories}
                />}
            />
            {errors.categorias && (<AlertErrorForm messageError={errors.categorias.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4">
            <label htmlFor="foto_portada" className="form-label fs-base text-white">Foto de evento</label>
            <input
              type="file"
              id="foto_portada"
              className="form-control form-control-lg fw-bold"
              {...register('foto_portada')}
            />
            {errors.foto_portada && (<AlertErrorForm messageError={errors.foto_portada.message} />)}
          </div>
          <div className="col-sm-12 col-md-6 mb-4">
            <label htmlFor="itinerario" className="form-label fs-base text-white">Itinerario de evento (.pdf)</label>
            <input
              type="file"
              id="itinerario"
              className="form-control form-control-lg fw-bold"
              {...register('itinerario')}
            />
            {errors.itinerario && (<AlertErrorForm messageError={errors.itinerario.message} />)}
          </div>
        </div>
        <FormButtons backPage="/crear-evento"/>
      </form>
    </>
  )
}
